import { generateMediaURL } from 'helpers/generateMediaURL';

/**
 * Events reach the calendar from two places: the Strapi admin and the e-phan
 * competition API. e-phan gives absolute media URLs and its own location fields,
 * so these helpers pick whichever source the event actually has.
 */

export const isEphanEvent = ({ source }) => source === 'ephan';

/** Strapi media paths need the API host; e-phan URLs are already absolute. */
export const getEventCover = ({ cover, ephanBannerVerticalUrl, ephanBannerUrl } = {}) =>
  generateMediaURL(cover?.url) || ephanBannerVerticalUrl || ephanBannerUrl || null;

export const getEventEntryForm = ({ entryForm, ephanEntryFormUrl } = {}) =>
  generateMediaURL(entryForm?.url) || ephanEntryFormUrl || null;

/** Imported competitions may happen where ECDS has no member organization. */
export const getEventCountry = ({ country, organization } = {}) => country || organization?.country || '';

export const getEventOrganizationName = ({ organization } = {}) =>
  organization?.shortName || organization?.name || '';

/** e-phan enum values are stored underscored; show them the way it writes them. */
export const formatEntryType = (entryType) => (entryType ? entryType.replace(/_/g, '-') : '');
